<template>
  <div class="dialog-wrap">
    <el-dialog
      title="提现详情"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="880px">
      <div class="header-wrap">
        <div class="header-item">
          <p>本次申请提现：{{withdrawInfo.amount || 0}}元</p>
        </div>
        <div class="header-item">
          <p>收款方式：{{handleRender(withdrawInfo.fee_account_type, 'payType')}}</p>
          <p>收款人姓名：{{withdrawInfo.fee_account_name}}</p>
          <p>收款人账号：{{withdrawInfo.fee_account_card}}</p>
        </div>
        <div class="header-item">
          <p>提现状态：
            <el-tag v-if="withdrawInfo.status === 0">提现中</el-tag>
            <el-tag type="success" v-if="withdrawInfo.status === 1">提现成功</el-tag>
            <el-tag type="danger" v-if="withdrawInfo.status === 2">提现已撤销</el-tag>
            <el-tag type="danger" v-if="withdrawInfo.status === 3">提现被驳回</el-tag>
          </p>
          <div v-if="withdrawInfo.status === 0">
            <el-button size="mini" type="primary">审核通过，确认已打款</el-button>
            <el-button size="mini" plain @click="handleWithdrawCancel">审核不通过，驳回提现</el-button>
          </div>
        </div>
      </div>
      <el-divider></el-divider>
      <div class="table-wrap">
        <div class="title">
          <h3>提现订单核对</h3>
          <!-- <el-button class="export-button" type="text">下载excel</el-button> -->
        </div>
        <el-table
            :data="results"
            border
            style="width: 100%">
            <el-table-column
              prop="order_id"
              label="订单ID"
              width="80"
              align="center">
            </el-table-column>
            <el-table-column
              label="商品类型"
              width="100"
              align="center">
              <template slot-scope="scope">
                <span>{{ handleRender(scope.row.goods_type, 'productType') }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="商品名称"
              align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.goods_name }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="user_nickname"
              label="购买用户"
              width="100"
              align="center">
            </el-table-column>
            <el-table-column
              label="订单金额(元)"
              width="100"
              align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.amount }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="支付时间"
              width="140"
              align="center">
              <template slot-scope="scope">
                <span>{{  $moment(scope.row.create_time).format('YYYY-MM-DD hh:mm')  }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="订单收入(元)"
              width="100"
              align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.amount }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="结算状态"
              width="100"
              align="center">
              <template slot-scope="scope">
                <span>{{ handleRender(scope.row.status, 'status') }}</span>
              </template>
            </el-table-column>
          </el-table>
      </div>
      <div class="footer-wrap">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { seniorProfitLogs, seniorWithdrawOne, seniorWithdrawRevoke } from '@/api/senior'
import { getStorage } from '@/utils/helper'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => {return {}}
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      query: {
        ids: '',
        status: 1,
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize') ? Number(localStorage.getItem('pageSize')) : 10,
        isPaging: 1
      },
      pageTotal: 10,
      withdrawInfo: {},
      profitInfo: {},
      results: []
    }
  },
  watch: {
    visible (val) {
      this.dialogVisible = val

      if (val) {
        this.fetchWithdrawInfo()
      }
    }
  },
  methods: {
    // 提现信息查询
    fetchWithdrawInfo() {
      seniorWithdrawOne({id: this.content.id}).then(res => {
        this.withdrawInfo = res
        if (res.ref_ids) {
          this.query.ids = res.ref_ids
          this.fetchProfitLogs()
        }
      })
    },
    // 驳回提现
    handleWithdrawCancel() {
      // 二次确认撤销
      this.$confirm("确定要驳回吗？", "提示", {
        type: "warning",
      }).then(() => {
        seniorWithdrawRevoke({ withdraw_id: this.withdrawInfo.id }).then((res) => {
          this.$message.success(`驳回成功`);
          this.$emit('submit')
          this.handleClose()
        })
      }).catch(() => {});
    },
    // 学长营收记录请求
    fetchProfitLogs() {
      seniorProfitLogs(this.query).then(res => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchProfitLogs()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchProfitLogs()
    },
    handleClose() {
      this.$emit('close')
    },
    handleRender(value, type) {
      let productTypes = {
        '1': '课程',
        '2': '题库',
        '3': '阅读资料',
        '4': '实体资料'
      }
      let status = {
        '0': '待结算',
        '1': '已入账',
        '2': '已撤单',
      }
      let payTypes = {
        '1': '支付宝',
        '2': '微信'
      }
      if (type == 'productType') {
        return productTypes[value] || ''
      } else if (type == 'status') {
        return status[value] || ''
      } else if (type == 'payType') {
        return payTypes[value] || ''
      }
      return ''
    },
  }
}
</script>

<style lang="less" scoped>
  .dialog-wrap {

    .header-item {
      display: flex;
      align-items: center;

      &+.header-item {
        margin-top: 10px;
      }
      &>p {
        font-weight: bold;
        margin-right: 20px;
      }
    }
    .table-wrap {

      .title {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
      }
      .export-button {
        padding: 0;
        margin-left: 10px;
      }
    }
    .footer-wrap  {
      display: flex;
      justify-content: center;
      margin-top: 10px;
    }
  }
</style>
